import {Component} from '@angular/core';

@Component({
  selector: 'spt-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss']
})
export class EulaComponent {}
